<template>
  <div>
    <!--   所属分类-->
    <div class="filter-con" style="padding-top: 0px;">
      <div class="sceneTitle">所属分类</div>
      <div class="tag-con">
        <el-popover
          :key="tag.id"
          v-for="tag in tagList"
          placement="bottom"
          trigger="click"
          :ref="'popover-' + tag.id"
          @show="onPopoverShow(tag.id)"
        >
          <div>
            <el-cascader-panel
              v-model="tag.select"
              @change="onCascaderChange"
              :options="tag.childrens"
              :props="tagProps"
            ></el-cascader-panel>
          </div>
          <span slot="reference" :class="['tag', tag.select ? 'active' : '']">
                {{ (tag.select || "").toString() || tag.tagName }}
                <i class="el-icon-arrow-down"></i>
              </span>
        </el-popover>
      </div>
    </div>
    <div class="filter-con" v-if="selectTags.length > 0" style="padding-top: 5px">
      <div class="title">已选：</div>
      <div class="tag-con">
      <span class="sel-tag" v-for="tag in selectTags" :key="tag">
        {{ tag }}
        <span @click="onSelectTagRemove(tag)" class="del"></span>
      </span>
      </div>
    </div>
    <div style="background-color: #fff">
      <div class="list">
        <div class="item" :key="item.id" v-for="item in dataList">
          <div class="img">
            <el-tooltip class="itemlist" effect="dark" placement="bottom" popper-class="tool-tip" v-if="item.tags.length != 0 && item.tags">
              <div slot="content">
                <div>
                  标签：
                  <span v-for="(tag,index) of item.tags" :key="tag.id">{{ tag.tagName }}
                    <span v-if="index != item.tags.length - 1">,</span>
                  </span>
                </div>
              </div>
<!--              <el-image-->
<!--                :preview-src-list="previewSrcList"-->
<!--                :src="item.url"-->
<!--                fit="fit"-->
<!--                class="img"-->
<!--              />-->
              <div
                :style="{
                    background: `url('${item.url}') no-repeat center center /100% 100%`,
                    width: '100%',
                    height: '100%',
                    backgroundSize: 'cover'
                  }"

                @mouseenter="bigPic(item)"
                @mouseleave="bigPic(item)"
              >
                <div class="image_show" v-if="item.imageShow" @click="openImage(item)">
                  <i class="el-icon-view"></i>
                </div>
              </div>
            </el-tooltip>
            <div
              :style="{
                    background: `url('${item.url}') no-repeat center center /100% 100%`,
                    width: '100%',
                    height: '100%',
                    backgroundSize: 'cover'
                  }"
              v-else
              @mouseenter="bigPic(item)"
              @mouseleave="bigPic(item)"
            >
              <div class="image_show" v-if="item.imageShow" @click="openImage(item)">
                <i class="el-icon-view"></i>
              </div>
            </div>
<!--            <el-image-viewer-->
<!--              v-if="showPreview"-->
<!--              :on-close="closeViewer"-->
<!--              :url-list="picList"-->
<!--            />-->
          </div>
          <div class="info">
            <div class="title">{{ item.image.name }}</div>
            <div class="date">创建于 {{ item.createTime }}</div>
          </div>
        </div>
      </div>

      <div v-if="dataList.length === 0" class="decs">暂无数据</div>
      <div>
        <el-pagination
          @size-change="sizeChangeHandleHis"
          @current-change="currentChangeHandleHis"
          :current-page="pageNum"
          :page-sizes="[12, 24, 36, 50, 100]"
          :page-size="pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;padding-bottom: 20px;margin: 25px 50px">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getSceneList, moduleList, dataList } from "@/api/queriesList";
import { getGalleryList, getGalleryTagList } from "../../api/gallery";
import moment from "moment";

export default {
  name: "demonstrate",
  props: {
    fileName: {
      type: String,
      default: () => null
    },
    tagName: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      picList: '',
      showPreview: false,
      pageNum: 1,
      pageSize: 12,
      sceneNum: 0,
      total:0,
      sceneList: [],
      tagList: [],
      popoverId: null,
      tagProps: {
        value: "tagName",
        label: "tagName",
        children: "childrens",
        checkStrictly: true
      },
      dataList: [],
      selectList:[],
      previewSrcList: []
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  computed: {
    selectTags() {
      console.log(this.$store.state, "this.$store");
      let result = [];

      let getTags = list => {
        list?.forEach(item => {
          if (item.select) {
            result.push(item.select.toString());
          }
          getTags(item.childrens);
        });
      };

      getTags(this.tagList);
      return result;
    },
    selectTagIds() {
      let result = [];
      let getTagIds = list => {
        list?.forEach(item => {
          if (item.select) {
            const tagName = [item.select[item.select.length-1]];
            let selectOne = item.childrens?.find(aa => aa.tagName == tagName);
            if(!selectOne) {
              item.childrens?.forEach(obj => {
                let selectTag = obj.childrens?.find(oo => oo.tagName == tagName);
                if (selectTag) {
                  result.push(selectTag.id);
                }
              });
            }else {
              result.push(selectOne.id);
            }
          }
          getTagIds(item.childrens);
        });
      };
      getTagIds(this.tagList);
      return result;
    },
  },
  mounted() {
    this.getAllTags();
  },
  methods: {
    bigPic(item) {
      item.imageShow = item.imageShow ? false : true
    },
    openImage(item) {
      // 调用image组件中的大图浏览图片方法
      this.$refs.preview.clickHandler()
      this.picList = item.urlSource
      this.showPreview = true
    },
    closeViewer() {
      this.dataList.forEach(item => {
        item.imageShow = false
      })
      // item.imageShow = false
      this.picList = []
      this.showPreview = false
    },
    getAllTags() {
      this.tagList = [];
      getGalleryTagList({ tagName: "" })
        .then(res => {
          console.log(res, "tags");
          if (res.code == 200) {
            let initModel = list => {
              (list.children || []).forEach(item => {
                item.select = null;
                initModel(item.childrens);
              });
            };
            let tagList = res.data.childrens;
            initModel(tagList);

            this.tagList = tagList;
          }
        })
        .finally(_ => {
          this.pageNum = 1
          this.getGalleryList();
        });
    },
    onPopoverShow(id) {
      this.popoverId = id;
    },
    onSelectTagRemove(tag) {
      console.log(tag);
      let firstTage = tag.split(",")[0];
      this.tagList?.forEach(item => {
        let hasTag = item.childrens?.find(obj => obj.tagName == firstTage);
        if (hasTag) {
          item.select = null;
        }
      });

      this.getList();
    },
    onCascaderChange(e) {
      this.pageNum = 1
      console.log(e, "eeeee");
      console.log(this.$refs, "refs");
      this.$refs["popover-" + this.popoverId][0].doClose();
      this.getList();
    },
    getGalleryList() {
      let data = {
        // moduleIds: [2],
        tagSearchValue: this.tagName,
        tagIds: this.selectTagIds,
        name: this.fileName,
        startTime: "",
        rootModuleId: '2',
        endTime: "",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: 1,
        type: 0
      };
      getGalleryList(data).then(res => {
        console.log(res, "res");
        if (res.code == 200) {
          let records = res.data.records;
          records.forEach(item => {
            item.createTime = item.createTime.replace("T", " ").slice(0, 16);
            this.previewSrcList.push(item.url)
            item.imageShow = false
          });
          this.dataList = records;
          this.total = res.data.total
        }
      });
    },
    getList() {
      this.pageNum = 1;
      this.getGalleryList();
    },
    // 每页数
    sizeChangeHandleHis (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getGalleryList()
    },
    // 当前页
    currentChangeHandleHis (val) {
      this.pageNum = val
      this.getGalleryList()
    },
  },
}
</script>

<style>
.tool-tip{
  min-width: 3.2rem;
}
</style>
<style scoped lang="less">
.hideImgDiv {
  ::v-deep .el-image__inner {
    display: none;
  }
}
.decs{
  text-align: center;
  color: #7d7d7d;
}
::v-deep .el-radio__inner {
  top: -18px;
  left: -19px;
  border-radius: 0;
  border: 0;
  width: 170px;
  height: 34px;
  background-color: transparent;
  cursor: pointer;
  box-sizing: border-box;
  position: absolute;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: transparent;
}
::v-deep .el-image {
  width: 3.4rem;
  height: 1.9rem;
  border-radius: 0.12rem;
}
::v-deep .el-image__inner{
   overflow: hidden;
   object-fit: cover;
 }
.img {
  height: 1.9rem;
  border-radius: 0.12rem;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}
.image_show{
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 6px;
  text-align: center;
  float: right;
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
  font-weight: bold;
  margin-right: 5px;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 5px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  & > .item {
    flex: 0 0 3.43rem;
    margin: 0.16rem;
    margin-bottom: 0;
    width: 3.43rem;
    & > .info {
      padding-bottom: 0.16rem;
      & > .title {
        font-size: 0.14rem;
        color: rgba(0, 0, 0, 0.85);
        padding-top: 0.12rem;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        // height: .64rem;
      }
      & > .tags {
        & > span {
          font-size: 0.12rem;
          color: rgba(0, 0, 0, 0.85);
          line-height: 0.2rem;
          font-weight: 400;
          display: inline-block;
        }
      }
      & > .date {
        color: rgba(0, 0, 0, 0.45);
        font-size: 0.12rem;
        padding-top: 0.04rem;
      }
    }
  }
}
.sceneBut{
  background: #FFCCC7;
  color: #E60027 ;
  border-color: #FFCCC7 !important;
}
.filter-con {
  padding: 0.1rem 0.3rem;
  display: flex;
  align-items: center;
  & > .title {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-weight: bold;
  }
  & > .sceneTitle{
    margin-top: 5px;
    width: 100px;
    line-height: 32px;
    font-size: 14px;
    font-family: Inter-Medium, Inter;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
  }
  & > .tag-con {
    flex: 1;
    & .tag {
      display: inline-block;
      border-radius: 18px;
      border: 1px solid #c0c4cc;
      margin: 0 0.04rem;
      line-height: 34px;
      padding: 0 0.16rem;
      position: relative;
      cursor: pointer;
      font-size: 14px;
      margin-top: 8px;
      &.active {
        background-color: #ffccc7;
        color: #e60027;
        border-color: #ffccc7;
      }
    }
    & .sel-tag {
      padding: 0 0.12rem;
      background-color: #f5f5f5;
      color: rgba(0, 0, 0, 0.6);
      line-height: 0.28rem;
      height: 0.28rem;
      display: inline-block;
      font-size: 0.14rem;
      margin: 0 0.06rem;
      position: relative;
      & > .del {
        position: absolute;
        width: 0.16rem;
        height: 0.16rem;
        background: url("~@/assets/imgs/icon_gray_close@2x.png") no-repeat center center / 100% auto;
        top: -0.08rem;
        right: -0.04rem;
        cursor: pointer;
      }
    }
  }
}
.scene{
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  padding-left: 24px;
  .sceneTitle{
    margin-top: 5px;
    width: 100px;
    line-height: 32px;
    font-size: 14px;
    font-family: Inter-Medium, Inter;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
  }
}
.sceneConten{
  display: flex;
  flex-wrap: wrap;
  div{
    line-height: 34px;
    width: 95px;
    border-radius: 18px;
    opacity: 1;
    border: 1px solid #c0c4cc;
    text-align: center;
    margin-right: 8px;
    cursor: pointer;
  }
}
</style>
